module.exports = __webpack_public_path__ + "static/media/logo.c5c0f43d.svg";